import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import TableComponent from "../components/TableComponent";
import { Container, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../utils/helpers";

import { useDispatch } from "react-redux";
import { setSampleCode } from "../redux/sampleSlice";
import { useAuth } from "../context/AuthContext";
import { FaFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { encryptId } from "../utils/helpers";
import { decryptId } from "../utils/helpers";

import Select from "react-select";


import { Modal, Form } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

function Patient_report_sample_id_wise() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useAuth();

    const [dataEntry, setDataEntry] = useState([]);
    ///////////////////////////////////////
    const [status, setStatus] = useState("");
    const { maleID } = useParams();
    const decodedId = decodeURIComponent(maleID);

    useEffect(() => {
        try {
            const decodedId = decodeURIComponent(maleID);
            const decryptedStatus = decryptId(decodedId);

            // Strict validation
            if (
                decryptedStatus !== "active" &&
                decryptedStatus !== "deleted"
            ) {
                alert("Invalid URL");
                navigate("/dashboard");
                return;
            }

            setStatus(decryptedStatus);

        } catch (error) {
            console.error(error);
            alert("Invalid URL");
            navigate("/dashboard");
        }
    }, [maleID, navigate]);
    ///////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [error, setError] = useState("");

    const [deleteMode, setDeleteMode] = useState(false);

    const [activateMode, setActiveMode] = useState(false);




    ////////////////////////////


    //////////////////////////////////
    // Fetch Data
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${API_URL}/patient_report_sample_id_wise`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setDataEntry(res.data.literatures || []);
            })
            .catch((err) => console.error("Error fetching data:", err));
    }, []);


    const filteredData = useMemo(() => {
        if (!user) return [];

        let filtered = [...dataEntry];

        // ✅ 1. ROLE FILTER
        if (user.role === "0") {
            filtered = filtered.filter(
                (item) => item.user_id === user.uid
            );
        }

        // Admin (role 1) sees all → no restriction applied

        // ✅ 2. STATUS FILTER
        if (status === "active") {
            filtered = filtered.filter(item => item.active == 1);
        }

        if (status === "deleted") {
            filtered = filtered.filter(item => item.active == 0);
        }

        return filtered;
    }, [dataEntry, user, status]);

    const openPasswordModal = (sample_master_id) => {
        setSelectedId(sample_master_id);
        setPassword("");
        setError("");
        setShowModal(true);

    };

    const deleteRecordModal = (sample_master_id) => {
        setSelectedId(sample_master_id);
        setPassword("");
        setError("");
        setDeleteMode(true);
        setShowModal(true);
    };


    const activateRecordModel = (sample_master_id) => {
        setSelectedId(sample_master_id);
        setPassword("");
        setError("");
        setDeleteMode(false);
        setActiveMode(true);
        setShowModal(true);
    };
    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password, uid: user?.uid },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (!res.data.success) {
                setError("Incorrect password");
                return;
            }

            setShowModal(false);

            // 🔥 DELETE MODE
            if (deleteMode) {
                await handleDelete(selectedId);
                setDeleteMode(false);
                return;
            }

            // 🔥 ACTIVATE MODE
            if (activateMode) {
                await activateRecord(selectedId);
                setActiveMode(false);
                return;
            }

            // 🔥 EDIT MODE
            const encryptedId = encryptId(selectedId);
            navigate(`/Update_Male_Details/${encodeURIComponent(encryptedId)}`);

        } catch (err) {
            setError("Server error");
        }
    };
    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.delete(
                `${API_URL}/delete_partner/${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (res.data.status) {
                setDataEntry(prev =>
                    prev.filter(item => item.sample_master_id !== id)
                );

                alert("Deleted successfully");
            } else {
                alert(res.data.message || "Delete failed");
            }

        } catch (err) {
            console.error(err);
            alert("Server error during delete");
        }
    };

    const activateRecord = async (id) => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/activate_partner_record`,
                { id },   // ✅ correct body
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.data.status) {
                setDataEntry(prev =>
                    prev.map(item =>
                        item.sample_master_id === id
                            ? { ...item, active: 1 }
                            : item
                    )
                );

                alert("Record activated successfully");
            } else {
                alert(res.data.message || "Activation failed");
            }

        } catch (err) {
            console.error(err);
            alert("Server error during activation");
        }
    };
    // const verifyPassword = async () => {
    //     try {
    //         const token = localStorage.getItem("token");

    //         const res = await axios.post(
    //             `${API_URL}/verify-password`,
    //             { password, uid: user?.uid },
    //             {
    //                 headers: { Authorization: `Bearer ${token}` },
    //             }
    //         );
    //         const encryptedId = encryptId(selectedId);
    //         const safeId = encodeURIComponent(encryptedId);

    //         if (res.data.success) {


    //             setShowModal(false);
    //             if (!deleteMode) {
    //                 navigate(`/Update_Male_Details/${safeId}`);
    //                 return;
    //             }


    //             // ❌ DELETE MODE
    //             await axios.delete(

    //                 `${API_URL}/delete_partner/${selectedId}`,
    //                 {
    //                     headers: { Authorization: `Bearer ${token}` },
    //                 }
    //             );
    //             // navigate(`/Update_Male_Details/${safeId}`);
    //             // refresh list
    //             setDataEntry(prev =>
    //                 prev.filter(item => item.sample_master_id !== selectedId)
    //             );

    //             setDeleteMode(false);

    //         } else {
    //             setError("Incorrect password");
    //         }
    //     } catch (err) {
    //         setError("Incorrect password");
    //     }
    // };
    // const handleEdit = (sample_master_id) => {
    //     navigate(`/Update_Male_Details/${sample_master_id}`);
    // };

    const handlePrint = (sample_master_id) => {
        window.open(`/All_Report_download/${sample_master_id}`, "_blank");
    };
    //////////////////////////////////////////////////////////////////////////////
    const handlePrint_Excel = async (male_id) => {
        try {

            const token = localStorage.getItem("token");
            if (!token) return;

            const res = await axios.get(
                `${API_URL}/partner_details_all_data_id_wise/${male_id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const data = res.data.partner_data;
            if (!data) return;

            const sampleId = data?.male?.sample_id || "Sample_ID";
            const prd = sampleId.split("/")[2];

            let excelData = [];
            let count = 1;

            // ===============================
            // CONFIG
            // ===============================

            const skipFields = [
                "pmid", "id", "pfid", "sample_id", "assay_id",
                "sample_master_id", "created_by", "created_date",
                "mena_id", "ydata_id", "comet_id", "data_id",
                "kit_id", "telomere_id", "followup_id"
            ];

            const followupSections = [
                "followup_14days",
                "followup_11_13weeks",
                "followup_18_20weeks",
                "followup_24weeks",
                "followup_fertilization_master"
            ];

            const followupLockMap = {
                IUI: ["IVF", "ICSI"],
                IVF: ["IUI", "ICSI"],
                ICSI: ["IUI", "IVF"],
            };

            const lockedTypes = followupLockMap[prd] || [];

            // ===============================
            // HELPERS
            // ===============================

            const formatLabel = (text) =>
                text.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());

            const formatValue = (key, value) => {
                const num = Number(value);

                const smokingMap = {
                    1: "No",
                    2: "Former Smoker",
                    3: "Current Smoker (Daily)",
                    4: "Current Smoker (Occasional)",
                    5: "Data Not Available"
                };

                const tobaccoMap = {
                    1: "No",
                    2: "Former User",
                    3: "Current User (Active)",
                    4: "Current User (Occasional)",
                    5: "Data Not Available"
                };

                const alcoholMap = {
                    1: "No",
                    2: "Former Drinker",
                    3: "Current Drinker (Active)",
                    4: "Current Drinker (Occasional)",
                    5: "Data Not Available"
                };

                const yesNoMap = {
                    0: "No",
                    1: "Yes",
                    2: "Data Not Available"
                };

                if (key === "Smoking") return smokingMap[num] || "Unknown";
                if (key === "Chewing_Tobacco") return tobaccoMap[num] || "Unknown";
                if (key === "Alcohol") return alcoholMap[num] || "Unknown";

                const yesNoFields = [
                    "Diabetes", "Hypertension", "Mumps", "Trauma",
                    "Surgeries", "Hernia", "Varicocele",
                    "Undescended_Testes", "Vasectomy", "STD_Genital_Discharges"
                ];

                if (yesNoFields.includes(key)) {
                    return yesNoMap[num] || "Unknown";
                }

                return value ?? "";
            };

            // ===============================
            // PROCESS DATA
            // ===============================

            Object.entries(data).forEach(([sectionName, sectionValue]) => {

                const isFollowup = followupSections.includes(sectionName);

                // ARRAY TYPE
                if (Array.isArray(sectionValue)) {

                    sectionValue.forEach((item) => {

                        Object.entries(item).forEach(([key, value]) => {

                            if (skipFields.includes(key)) return;

                            let finalValue = formatValue(key, value);

                            // ONLY FOLLOWUP LOGIC
                            // if (isFollowup && item.followup_type) {
                            //     if (lockedTypes.includes(item.followup_type)) {
                            //         finalValue = "@";
                            //     }
                            // }

                            if (isFollowup && item.followup_type) {

                                // show original followup_type always
                                if (key === "followup_type") {
                                    finalValue = value;
                                }

                                // if type not matched with PRD then show @ for other fields
                                else if (item.followup_type !== prd) {
                                    finalValue = "@";
                                }
                            }

                            excelData.push({
                                "Sr No": count++,
                                "Form ": formatLabel(sectionName),
                                "Label Name": formatLabel(key),
                                [sampleId]: finalValue
                            });
                        });
                    });
                }

                // OBJECT TYPE
                else if (typeof sectionValue === "object" && sectionValue !== null) {

                    Object.entries(sectionValue).forEach(([key, value]) => {

                        if (skipFields.includes(key)) return;

                        excelData.push({
                            "Sr No": count++,
                            "Form ": formatLabel(sectionName),
                            "Label Name": formatLabel(key),
                            [sampleId]: formatValue(key, value)
                        });
                    });
                }
            });

            // ===============================
            // EXPORT EXCEL
            // ===============================

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            worksheet["!cols"] = [
                { wch: 8 },
                { wch: 30 },
                { wch: 45 },
                { wch: 60 }
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Full Report");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelBuffer], {
                type: "application/octet-stream",
            });

            const today = new Date();
            const todayDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

            const safeSampleId = sampleId.replaceAll("/", "_");

            saveAs(
                blob,
                `Full_Partner_Report_${safeSampleId}_${todayDate}.xlsx`
            );

        } catch (error) {
            console.error("Excel Download Error:", error);
        }
    };

    // const handlePrint_Excel = async (male_id) => {
    //     try {
    //         const token = localStorage.getItem("token");
    //         if (!token) return;

    //         const res = await axios.get(
    //             `${API_URL}/partner_details_all_data_id_wise/${male_id}`,
    //             { headers: { Authorization: `Bearer ${token}` } }
    //         );

    //         const data = res.data.partner_data;
    //         if (!data) return;

    //         const sampleId = data?.male?.sample_id || "Sample_ID";
    //         const prd = sampleId.split("/")[2]; // e.g., IUI
    //         alert(prd);

    //         let excelData = [];
    //         let count = 1;

    //         const skipFields = [
    //             "pmid", "id", "pfid", "sample_id", "assay_id",
    //             "sample_master_id", "created_by", "created_date",
    //             "mena_id", "ydata_id", "comet_id", "data_id",
    //             "kit_id", "telomere_id", "followup_id"
    //         ];

    //         const formatLabel = (text) =>
    //             text?.replace(/_/g, " ")?.replace(/\b\w/g, l => l.toUpperCase());

    //         const formatValue = (key, value) => value ?? "";

    //         const followupSections = [
    //             "followup_14days",
    //             "followup_11_13weeks",
    //             "followup_18_20weeks",
    //             "followup_24weeks",
    //             "followup_fertilization_master"
    //         ];


    //         const followupFields = [
    //             "record_date",
    //             "UPT",
    //             "hcg_value",
    //             "gsgc_value",
    //             "fetal_pole",
    //             "cardiac_echo",
    //             "remark"
    //         ];

    //         Object.entries(data).forEach(([sectionName, sectionValue]) => {

    //             // 1️⃣ FOLLOWUP FILTER
    //             if (followupSections.includes(sectionName)) {

    //                 if (Array.isArray(sectionValue)) {

    //                     sectionValue.forEach(item => {

    //                         // Check Followup_Type for this row
    //                         const type = item?.followup_type;

    //                         Object.entries(item).forEach(([key, value]) => {

    //                             if (skipFields.includes(key)) return;

    //                             // If the key is Followup_Type → only show prd, else "@"
    //                             let cellValue = value;
    //                             if (key === "followup_type") {
    //                                 cellValue = (type === prd) ? value : "@";
    //                             }

    //                             if (type !== prd && followupFields.includes(key)) {
    //                                 cellValue = "@";
    //                             }

    //                             excelData.push({
    //                                 "Sr No": count++,
    //                                 "Form": formatLabel(sectionName),
    //                                 "Label Name": formatLabel(key),
    //                                 [sampleId]: cellValue
    //                             });
    //                         });
    //                     });
    //                 }

    //                 return; // skip normal array/object logic for followups
    //             }

    //             // 2️⃣ OTHER ARRAY SECTIONS
    //             if (Array.isArray(sectionValue)) {
    //                 sectionValue.forEach(item => {
    //                     Object.entries(item).forEach(([key, value]) => {
    //                         if (skipFields.includes(key)) return;

    //                         excelData.push({
    //                             "Sr No": count++,
    //                             "Form": formatLabel(sectionName),
    //                             "Label Name": formatLabel(key),
    //                             [sampleId]: formatValue(key, value)
    //                         });
    //                     });
    //                 });
    //             }

    //             // 3️⃣ OBJECT SECTIONS
    //             else if (typeof sectionValue === "object" && sectionValue !== null) {
    //                 Object.entries(sectionValue).forEach(([key, value]) => {
    //                     if (skipFields.includes(key)) return;

    //                     excelData.push({
    //                         "Sr No": count++,
    //                         "Form": formatLabel(sectionName),
    //                         "Label Name": formatLabel(key),
    //                         [sampleId]: formatValue(key, value)
    //                     });
    //                 });
    //             }

    //         });

    //         // CREATE EXCEL
    //         const worksheet = XLSX.utils.json_to_sheet(excelData);
    //         worksheet["!cols"] = [{ wch: 8 }, { wch: 30 }, { wch: 45 }, { wch: 60 }];

    //         const workbook = XLSX.utils.book_new();
    //         XLSX.utils.book_append_sheet(workbook, worksheet, "Full Report");

    //         const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    //         const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    //         const today = new Date();
    //         const todayDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    //         const safeSampleId = sampleId.replaceAll("/", "_");

    //         saveAs(blob, `Full_Partner_Report_${safeSampleId}_${todayDate}.xlsx`);

    //     } catch (error) {
    //         console.error("Excel Download Error:", error);
    //     }
    // };
    /////////////////////////////start data convert into a excel file //////////////////////////////////////////////////////


    const [center, setCenter] = useState("");
    const [cycle, setCycle] = useState("");
    const [procedure, setProcedure] = useState([]);
    const [center_list, setCenter_list] = useState([]);

    const [crn, setCrn] = useState([]);

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [sampleFrom, setSampleFrom] = useState("");
    const [sampleTo, setSampleTo] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;
        axios.get(`${API_URL}/get_center_list`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((res) => {
                setCenter_list(res.data.center_list || []);
                // console.log("Center List:", res.data.center_list);
            })
            .catch((err) => {
                console.error("Center list error:", err);
            });
    }, []);

    ////////////cycle/////////////
    function toRoman(num) {
        const romanMap = [
            { value: 1000, numeral: "M" },
            { value: 900, numeral: "CM" },
            { value: 500, numeral: "D" },
            { value: 400, numeral: "CD" },
            { value: 100, numeral: "C" },
            { value: 90, numeral: "XC" },
            { value: 50, numeral: "L" },
            { value: 40, numeral: "XL" },
            { value: 10, numeral: "X" },
            { value: 9, numeral: "IX" },
            { value: 5, numeral: "V" },
            { value: 4, numeral: "IV" },
            { value: 1, numeral: "I" },
        ];
        let result = "";
        for (const { value, numeral } of romanMap) {
            while (num >= value) {
                result += numeral;
                num -= value;
            }
        }
        return result;
    }
    const romanNumbers = Array.from({ length: 50 }, (_, i) => toRoman(i + 1));
    // const isAdmin = loggedUser?.role === "1";

    const optionsRomanNumbers = romanNumbers.map((r) => ({
        value: r,
        label: r
    }));

    const procedureList = ["IUI", "IVF", "ICSI"];
    const optionsProcedure = procedureList.map((p) => ({
        value: p,
        label: p
    }));


    const buildFilters = () => {
        const filters = {};


        // 🔐 Always send user role
        if (user?.role) {
            filters.user_role = user.role;
        }
        // 🏥 Center logic
        if (user?.role === "1") {
            // Admin → use selected center
            if (center) filters.center = center;
        } else {
            // Non-admin → force user's center
            filters.center = user?.center_id; // or user.center (based on your data)
        }


        if (sampleFrom) filters.sample_from = sampleFrom;
        if (sampleTo) filters.sample_to = sampleTo;

        if (crn && Array.isArray(crn) && crn.length > 0) {
            filters.crn = crn; // send as array
        }

        if (fromDate) filters.from_date = fromDate;
        if (toDate) filters.to_date = toDate;

        if (cycle && cycle.length > 0) {
            filters.cycle = cycle.map(c => c.value); // for multi-select
        }

        if (procedure && procedure.length > 0) {
            filters.procedure = procedure.map(p => p.value);
        }

        if (status === "active") {
            filters.status = 1;
        }
        else if (status === "deleted") {
            filters.status = 0;
        }


        return filters;
    };
    // const fetchFilteredData = async () => {
    //     try {
    //         const token = localStorage.getItem("token");
    //         if (!token) return;

    //         const filters = buildFilters();

    //         const res = await axios.get(
    //             `${API_URL}/patient_report_sample_id_data_with_filters`,
    //             {
    //                 headers: { Authorization: `Bearer ${token}` },
    //                 params: filters, // ✅ send filters here
    //             }
    //         );

    //         // setDataEntry(res.data.literatures || []);
    //     } catch (err) {
    //         console.error("Error fetching data:", err);
    //     }
    // };

    const getSampleMasterIds = (literatures) => {
        if (!literatures || literatures.length === 0) return [];
        return literatures.map(item => item.sample_master_id);
    };


    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) return;

            const filters = buildFilters();

            const res = await axios.get(
                `${API_URL}/patient_report_sample_id_wise_data`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    params: filters, // ✅ works for no filters too
                }
            );

            setDataEntry(res.data.literatures || []);


            // Extract sample_master_id as comma-separated string
            // ✅ Use res.data.literatures here
            const sampleMasterIds = getSampleMasterIds(res.data.literatures);
            console.log("Sample Master IDs:", sampleMasterIds);

        } catch (err) {
            console.error("Error fetching data:", err);
        }
    };
    // useEffect(() => {
    //     fetchFilteredData();
    // }, [center, sampleFrom, sampleTo, crn, fromDate, toDate, cycle, procedure]);

    useEffect(() => {
        fetchData();
    }, [
        center,
        sampleFrom,
        sampleTo,
        crn,
        fromDate,
        toDate,
        cycle,
        procedure
    ]);


    const finalData = useMemo(() => {
        if (!user) return [];

        let data = [...dataEntry];


        if (user.role === "0") {
            data = data.filter(item => item.user_id === user.uid);
        }

        // STATUS filter
        if (status === "active") data = data.filter(item => Number(item.active) === 1);
        if (status === "deleted") data = data.filter(item => Number(item.active) === 0);

        return data;
    }, [dataEntry, user, status]);

    const handleExportAllSamples = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) return;

            if (!dataEntry || dataEntry.length === 0) {
                alert("No data to export!");
                return;
            }

            const sampleMasterIds = getSampleMasterIds(dataEntry);

            // Call the new multiple-ids API
            const res = await axios.post(
                `${API_URL}/partner_details_all_data_multiple_ids`,
                { sample_master_ids: sampleMasterIds },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const partnerData = res.data.partner_data;

            console.log("Partner data response:", partnerData);

            // Generate Excel
            generateExcelForMultipleSamples(partnerData);


        } catch (err) {
            console.error("Error exporting data:", err);
        }
    };

    // Excel function for multiple sample IDs
    // const generateExcelForMultipleSamples = (partnerDataArray) => {
    //     if (!partnerDataArray || partnerDataArray.length === 0) return;

    //     const skipFields = [
    //         "pmid",
    //         "id",
    //         "pfid",
    //         "sample_id",
    //         "assay_id",
    //         "sample_master_id",
    //         "created_by",
    //         "created_date",
    //         "mena_id",
    //         "ydata_id",
    //         "comet_id",
    //         "data_id",
    //         "kit_id",
    //         "telomere_id",
    //         "followup_id"
    //     ];
    //     const followupSections = [
    //         "followup_14days",
    //         "followup_11_13weeks",
    //         "followup_18_20weeks",
    //         "followup_24weeks",
    //         "followup_fertilization_master"
    //     ];

    //     const followupLockMap = {
    //         IUI: ["IVF", "ICSI"],
    //         IVF: ["IUI", "ICSI"],
    //         ICSI: ["IUI", "IVF"],
    //     };
    //     const formatLabel = (text) => {
    //         return text
    //             ?.replace(/_/g, " ")
    //             ?.replace(/\b\w/g, (l) => l.toUpperCase());
    //     };

    //     // SAME formatter from single export
    //     const formatValue = (key, value) => {
    //         const num = Number(value);

    //         const smokingMap = {
    //             1: "No",
    //             2: "Former Smoker",
    //             3: "Current Smoker (Daily)",
    //             4: "Current Smoker (Occasional)",
    //             5: "Data Not Available"
    //         };

    //         const tobaccoMap = {
    //             1: "No",
    //             2: "Former User",
    //             3: "Current User (Active)",
    //             4: "Current User (Occasional)",
    //             5: "Data Not Available"
    //         };

    //         const yesNoMap = {
    //             0: "No",
    //             1: "Yes",
    //             2: "Data Not Available"
    //         };

    //         const alcoholMap = {
    //             1: "No",
    //             2: "Former Drinker",
    //             3: "Current Drinker (Active)",
    //             4: "Current Drinker (Occasional)",
    //             5: "Data Not Available"
    //         };

    //         if (key === "smoking") return smokingMap[num] || value;
    //         if (key === "chewing_tobacco") return tobaccoMap[num] || value;
    //         if (key === "alcohol") return alcoholMap[num] || value;

    //         if (
    //             [
    //                 "diabetes",
    //                 "hypertension",
    //                 "mumps",
    //                 "trauma",
    //                 "surgeries",
    //                 "hernia",
    //                 "varicocele",
    //                 "undescended_testes",
    //                 "vasectomy",
    //                 "std_genital_discharges"
    //             ].includes(key)
    //         ) {
    //             return yesNoMap[num] || value;
    //         }

    //         return value ?? "";
    //     };

    //     // STEP 1: Collect all unique rows
    //     const rowMap = new Map();

    //     partnerDataArray.forEach((dataItem) => {
    //         Object.entries(dataItem).forEach(([sectionName, sectionValue]) => {

    //             // ARRAY SECTION
    //             if (Array.isArray(sectionValue)) {

    //                 sectionValue.forEach((item) => {

    //                     Object.entries(item).forEach(([key]) => {

    //                         if (skipFields.includes(key)) return;

    //                         const uniqueKey = `${sectionName}|${key}`;

    //                         if (!rowMap.has(uniqueKey)) {
    //                             rowMap.set(uniqueKey, {
    //                                 sectionName,
    //                                 key,
    //                                 Form: formatLabel(sectionName),
    //                                 "Label Name": formatLabel(key)
    //                             });
    //                         }
    //                     });
    //                 });
    //             }

    //             // OBJECT SECTION
    //             else if (
    //                 typeof sectionValue === "object" &&
    //                 sectionValue !== null
    //             ) {

    //                 Object.entries(sectionValue).forEach(([key]) => {

    //                     if (skipFields.includes(key)) return;

    //                     const uniqueKey = `${sectionName}|${key}`;

    //                     if (!rowMap.has(uniqueKey)) {
    //                         rowMap.set(uniqueKey, {
    //                             sectionName,
    //                             key,
    //                             Form: formatLabel(sectionName),
    //                             "Label Name": formatLabel(key)
    //                         });
    //                     }
    //                 });
    //             }
    //         });
    //     });

    //     const rows = Array.from(rowMap.values());

    //     // STEP 2: Generate excel rows
    //     const excelData = rows.map((row, index) => {

    //         const rowObj = {
    //             "Sr No": index + 1,
    //             "Form": row.Form,
    //             "Label Name": row["Label Name"]
    //         };

    //         partnerDataArray.forEach((dataItem) => {

    //             const sampleId =
    //                 dataItem?.male?.sample_id || "Unknown Sample";

    //             let value = "";

    //             const sectionValue = dataItem[row.sectionName];

    //             // ARRAY SECTION
    //             if (Array.isArray(sectionValue)) {

    //                 const values = [];

    //                 const prd = sampleId.split("/")[2];

    //                 sectionValue.forEach((item) => {

    //                     if (item[row.key] === undefined) return;

    //                     let finalValue = formatValue(
    //                         row.key,
    //                         item[row.key]
    //                     );

    //                     // ONLY APPLY FOR FOLLOWUP SECTIONS
    //                     if (
    //                         followupSections.includes(row.sectionName) &&
    //                         item.followup_type
    //                     ) {

    //                         // show type always
    //                         if (row.key === "followup_type") {

    //                             finalValue = item.followup_type;
    //                         }

    //                         // matched PRD -> original value
    //                         else if (item.followup_type === prd) {

    //                             finalValue = formatValue(
    //                                 row.key,
    //                                 item[row.key]
    //                             );
    //                         }

    //                         // unmatched -> @
    //                         else {

    //                             finalValue = "@";
    //                         }

    //                         // vertical display
    //                         values.push(
    //                             `${finalValue}`
    //                         );
    //                     }
    //                     else {

    //                         values.push(finalValue);
    //                     }
    //                 });

    //                 value = values.join("\n");
    //             }

    //             // OBJECT SECTION
    //             else if (
    //                 typeof sectionValue === "object" &&
    //                 sectionValue !== null
    //             ) {

    //                 if (sectionValue[row.key] !== undefined) {
    //                     value = formatValue(
    //                         row.key,
    //                         sectionValue[row.key]
    //                     );
    //                 }
    //             }

    //             rowObj[sampleId] = value;
    //         });

    //         return rowObj;
    //     });

    //     // STEP 3: Create worksheet
    //     const worksheet = XLSX.utils.json_to_sheet(excelData);

    //     worksheet["!cols"] = [
    //         { wch: 8 },
    //         { wch: 30 },
    //         { wch: 45 },
    //         ...partnerDataArray.map(() => ({ wch: 25 }))
    //     ];

    //     // STEP 4: Workbook
    //     const workbook = XLSX.utils.book_new();

    //     XLSX.utils.book_append_sheet(
    //         workbook,
    //         worksheet,
    //         "Multiple Samples"
    //     );

    //     const excelBuffer = XLSX.write(workbook, {
    //         bookType: "xlsx",
    //         type: "array"
    //     });

    //     const blob = new Blob([excelBuffer], {
    //         type: "application/octet-stream"
    //     });

    //     const today = new Date();
    //     const yyyy = today.getFullYear();
    //     const mm = String(today.getMonth() + 1).padStart(2, "0");
    //     const dd = String(today.getDate()).padStart(2, "0");

    //     const todayDate = `${yyyy}-${mm}-${dd}`;

    //     saveAs(
    //         blob,
    //         `Multiple_Samples_Report_${todayDate}.xlsx`
    //     );
    // };

    // const generateExcelForMultipleSamples = (partnerDataArray) => {

    //     if (!partnerDataArray || partnerDataArray.length === 0) return;

    //     const skipFields = [
    //         "pmid",
    //         "id",
    //         "pfid",
    //         "sample_id",
    //         "assay_id",
    //         "sample_master_id",
    //         "created_by",
    //         "created_date",
    //         "mena_id",
    //         "ydata_id",
    //         "comet_id",
    //         "data_id",
    //         "kit_id",
    //         "telomere_id",
    //         "followup_id"
    //     ];

    //     const followupSections = [
    //         "followup_14days",
    //         "followup_11_13weeks",
    //         "followup_18_20weeks",
    //         "followup_24weeks",
    //         "followup_fertilization_master"
    //     ];

    //     const formatLabel = (text) => {
    //         return text
    //             ?.replace(/_/g, " ")
    //             ?.replace(/\b\w/g, (l) => l.toUpperCase());
    //     };

    //     const formatValue = (key, value) => {

    //         const num = Number(value);

    //         const smokingMap = {
    //             1: "No",
    //             2: "Former Smoker",
    //             3: "Current Smoker (Daily)",
    //             4: "Current Smoker (Occasional)",
    //             5: "Data Not Available"
    //         };

    //         const tobaccoMap = {
    //             1: "No",
    //             2: "Former User",
    //             3: "Current User (Active)",
    //             4: "Current User (Occasional)",
    //             5: "Data Not Available"
    //         };

    //         const yesNoMap = {
    //             0: "No",
    //             1: "Yes",
    //             2: "Data Not Available"
    //         };

    //         const alcoholMap = {
    //             1: "No",
    //             2: "Former Drinker",
    //             3: "Current Drinker (Active)",
    //             4: "Current Drinker (Occasional)",
    //             5: "Data Not Available"
    //         };

    //         if (key === "smoking") {
    //             return smokingMap[num] || value;
    //         }

    //         if (key === "chewing_tobacco") {
    //             return tobaccoMap[num] || value;
    //         }

    //         if (key === "alcohol") {
    //             return alcoholMap[num] || value;
    //         }

    //         if (
    //             [
    //                 "diabetes",
    //                 "hypertension",
    //                 "mumps",
    //                 "trauma",
    //                 "surgeries",
    //                 "hernia",
    //                 "varicocele",
    //                 "undescended_testes",
    //                 "vasectomy",
    //                 "std_genital_discharges"
    //             ].includes(key)
    //         ) {
    //             return yesNoMap[num] || value;
    //         }

    //         return value ?? "";
    //     };

    //     // STEP 1: Collect unique rows
    //     const rowMap = new Map();

    //     partnerDataArray.forEach((dataItem) => {

    //         Object.entries(dataItem).forEach(
    //             ([sectionName, sectionValue]) => {

    //                 // ARRAY SECTION
    //                 if (Array.isArray(sectionValue)) {

    //                     sectionValue.forEach((item) => {

    //                         Object.keys(item).forEach((key) => {

    //                             if (skipFields.includes(key)) return;

    //                             const uniqueKey =
    //                                 `${sectionName}|${key}`;

    //                             if (!rowMap.has(uniqueKey)) {

    //                                 rowMap.set(uniqueKey, {
    //                                     sectionName,
    //                                     key,
    //                                     Form: formatLabel(sectionName),
    //                                     "Label Name":
    //                                         formatLabel(key)
    //                                 });
    //                             }
    //                         });
    //                     });
    //                 }

    //                 // OBJECT SECTION
    //                 else if (
    //                     typeof sectionValue === "object" &&
    //                     sectionValue !== null
    //                 ) {

    //                     Object.keys(sectionValue).forEach((key) => {

    //                         if (skipFields.includes(key)) return;

    //                         const uniqueKey =
    //                             `${sectionName}|${key}`;

    //                         if (!rowMap.has(uniqueKey)) {

    //                             rowMap.set(uniqueKey, {
    //                                 sectionName,
    //                                 key,
    //                                 Form: formatLabel(sectionName),
    //                                 "Label Name":
    //                                     formatLabel(key)
    //                             });
    //                         }
    //                     });
    //                 }
    //             }
    //         );
    //     });

    //     const rows = Array.from(rowMap.values());

    //     // STEP 2: Generate Excel Data
    //     const excelData = rows.map((row, index) => {

    //         const rowObj = {
    //             "Sr No": index + 1,
    //             "Form": row.Form,
    //             "Label Name": row["Label Name"]
    //         };

    //         partnerDataArray.forEach((dataItem) => {

    //             const sampleId =
    //                 dataItem?.male?.sample_id ||
    //                 "Unknown Sample";

    //             let value = "";

    //             const sectionValue =
    //                 dataItem[row.sectionName];

    //             // ARRAY SECTION
    //             if (Array.isArray(sectionValue)) {

    //                 const values = [];

    //                 const prd =
    //                     sampleId?.split("/")[2];

    //                 sectionValue.forEach((item) => {

    //                     if (
    //                         item[row.key] === undefined ||
    //                         item[row.key] === null
    //                     ) {
    //                         return;
    //                     }

    //                     let finalValue = "";

    //                     // FOLLOWUP LOGIC
    //                     if (
    //                         followupSections.includes(
    //                             row.sectionName
    //                         ) &&
    //                         item.followup_type
    //                     ) {

    //                         // followup type row
    //                         if (
    //                             row.key === "followup_type"
    //                         ) {

    //                             finalValue =
    //                                 item.followup_type;
    //                         }

    //                         // matching PRD
    //                         else if (
    //                             item.followup_type === prd
    //                         ) {

    //                             finalValue = formatValue(
    //                                 row.key,
    //                                 item[row.key]
    //                             );
    //                         }

    //                         // unmatched
    //                         else {

    //                             finalValue = "@";
    //                         }
    //                     }
    //                     else {

    //                         finalValue = formatValue(
    //                             row.key,
    //                             item[row.key]
    //                         );
    //                     }

    //                     if (
    //                         finalValue !== "" &&
    //                         finalValue !== undefined &&
    //                         finalValue !== null
    //                     ) {

    //                         values.push(
    //                             String(finalValue)
    //                         );
    //                     }
    //                 });

    //                 // REMOVE DUPLICATES
    //                 const uniqueValues = [
    //                     ...new Set(values)
    //                 ];

    //                 // MULTI LINE
    //                 value = uniqueValues.join("\n");
    //             }

    //             // OBJECT SECTION
    //             else if (
    //                 typeof sectionValue === "object" &&
    //                 sectionValue !== null
    //             ) {

    //                 if (
    //                     sectionValue[row.key] !== undefined
    //                 ) {

    //                     value = formatValue(
    //                         row.key,
    //                         sectionValue[row.key]
    //                     );
    //                 }
    //             }

    //             rowObj[sampleId] = value;
    //         });

    //         return rowObj;
    //     });

    //     // STEP 3: Create worksheet
    //     const worksheet =
    //         XLSX.utils.json_to_sheet(excelData);

    //     // COLUMN WIDTHS
    //     worksheet["!cols"] = [
    //         { wch: 10 },
    //         { wch: 35 },
    //         { wch: 45 },
    //         ...partnerDataArray.map(() => ({
    //             wch: 50
    //         }))
    //     ];

    //     // WRAP TEXT
    //     Object.keys(worksheet).forEach((cell) => {

    //         if (cell[0] === "!") return;

    //         worksheet[cell].s = {
    //             alignment: {
    //                 wrapText: true,
    //                 vertical: "top"
    //             }
    //         };
    //     });

    //     // STEP 4: Workbook
    //     const workbook =
    //         XLSX.utils.book_new();

    //     XLSX.utils.book_append_sheet(
    //         workbook,
    //         worksheet,
    //         "Multiple Samples"
    //     );

    //     // STEP 5: Generate file
    //     const excelBuffer = XLSX.write(
    //         workbook,
    //         {
    //             bookType: "xlsx",
    //             type: "array"
    //         }
    //     );

    //     const blob = new Blob(
    //         [excelBuffer],
    //         {
    //             type:
    //                 "application/octet-stream"
    //         }
    //     );

    //     const today = new Date();

    //     const yyyy =
    //         today.getFullYear();

    //     const mm = String(
    //         today.getMonth() + 1
    //     ).padStart(2, "0");

    //     const dd = String(
    //         today.getDate()
    //     ).padStart(2, "0");

    //     const todayDate =
    //         `${yyyy}-${mm}-${dd}`;

    //     saveAs(
    //         blob,
    //         `Multiple_Samples_Report_${todayDate}.xlsx`
    //     );
    // };
    const generateExcelForMultipleSamples = (partnerDataArray) => {

        try {

            if (!partnerDataArray || partnerDataArray.length === 0) {
                alert("No data found");
                return;
            }

            /* =====================================================
                CONFIG
            ===================================================== */

            const skipFields = [
                "pmid",
                "id",
                "fmid",
                "pfid",
                "sample_id",
                "assay_id",
                "sample_master_id",
                "created_by",
                "created_date",
                "mena_id",
                "ydata_id",
                "comet_id",
                "data_id",
                "kit_id",
                "telomere_id",
                "followup_id"
            ];

            const followupSections = [
                "followup_14days",
                "followup_11_13weeks",
                "followup_18_20weeks",
                "followup_24weeks",
                "followup_fertilization_master"
            ];

            const followupTypes = ["IUI", "IVF", "ICSI"];

            /* =====================================================
                HELPERS
            ===================================================== */

            const formatLabel = (text = "") => {
                return text
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, l => l.toUpperCase());
            };

            const formatValue = (key, value) => {

                if (
                    value === null ||
                    value === undefined ||
                    value === "null"
                ) {
                    return "";
                }

                const num = Number(value);

                const smokingMap = {
                    1: "No",
                    2: "Former Smoker",
                    3: "Current Smoker (Daily)",
                    4: "Current Smoker (Occasional)",
                    5: "Data Not Available"
                };

                const tobaccoMap = {
                    1: "No",
                    2: "Former User",
                    3: "Current User (Active)",
                    4: "Current User (Occasional)",
                    5: "Data Not Available"
                };

                const alcoholMap = {
                    1: "No",
                    2: "Former Drinker",
                    3: "Current Drinker (Active)",
                    4: "Current Drinker (Occasional)",
                    5: "Data Not Available"
                };

                const yesNoMap = {
                    0: "No",
                    1: "Yes",
                    2: "Data Not Available"
                };

                const yesNoFields = [
                    "diabetes",
                    "hypertension",
                    "mumps",
                    "trauma",
                    "surgeries",
                    "hernia",
                    "varicocele",
                    "undescended_testes",
                    "vasectomy",
                    "std_genital_discharges"
                ];

                if (key === "smoking") {
                    return smokingMap[num] || value;
                }

                if (key === "chewing_tobacco") {
                    return tobaccoMap[num] || value;
                }

                if (key === "alcohol") {
                    return alcoholMap[num] || value;
                }

                if (yesNoFields.includes(key)) {
                    return yesNoMap[num] || value;
                }

                return value;
            };

            /* =====================================================
                CREATE UNIQUE ROW STRUCTURE
            ===================================================== */

            const rowMap = new Map();

            partnerDataArray.forEach((dataItem) => {

                Object.entries(dataItem).forEach(([sectionName, sectionValue]) => {

                    // ARRAY SECTION
                    if (Array.isArray(sectionValue)) {

                        sectionValue.forEach((item) => {

                            Object.keys(item).forEach((key) => {

                                if (skipFields.includes(key)) return;

                                // FOLLOWUP UNIQUE KEY
                                if (followupSections.includes(sectionName)) {

                                    followupTypes.forEach((type) => {

                                        const uniqueKey =
                                            `${sectionName}_${key}_${type}`;

                                        if (!rowMap.has(uniqueKey)) {

                                            rowMap.set(uniqueKey, {
                                                sectionName,
                                                key,
                                                followupType: type,
                                                form: formatLabel(sectionName),
                                                label:
                                                    `${formatLabel(key)} (${type})`
                                            });
                                        }
                                    });
                                }

                                // NORMAL UNIQUE KEY
                                else {

                                    const uniqueKey =
                                        `${sectionName}_${key}`;

                                    if (!rowMap.has(uniqueKey)) {

                                        rowMap.set(uniqueKey, {
                                            sectionName,
                                            key,
                                            form: formatLabel(sectionName),
                                            label: formatLabel(key)
                                        });
                                    }
                                }
                            });
                        });
                    }

                    // OBJECT SECTION
                    else if (
                        typeof sectionValue === "object" &&
                        sectionValue !== null
                    ) {

                        Object.keys(sectionValue).forEach((key) => {

                            if (skipFields.includes(key)) return;

                            const uniqueKey =
                                `${sectionName}_${key}`;

                            if (!rowMap.has(uniqueKey)) {

                                rowMap.set(uniqueKey, {
                                    sectionName,
                                    key,
                                    form: formatLabel(sectionName),
                                    label: formatLabel(key)
                                });
                            }
                        });
                    }
                });
            });

            const rows = Array.from(rowMap.values());

            /* =====================================================
                GENERATE EXCEL DATA
            ===================================================== */

            const excelData = [];
            let srNo = 1;

            rows.forEach((row) => {

                // NORMAL SECTION
                if (!followupSections.includes(row.sectionName)) {

                    const rowObj = {
                        "Sr No": srNo++,
                        "Form": row.form,
                        "Label Name": row.label
                    };

                    partnerDataArray.forEach((dataItem) => {

                        const sampleId =
                            dataItem?.male?.sample_id ||
                            "Unknown Sample";

                        const sectionData =
                            dataItem[row.sectionName];

                        let finalValue = "";

                        // ARRAY SECTION
                        if (Array.isArray(sectionData)) {

                            const values = [];

                            sectionData.forEach((item) => {

                                if (
                                    item[row.key] !== undefined &&
                                    item[row.key] !== null
                                ) {

                                    values.push(
                                        formatValue(
                                            row.key,
                                            item[row.key]
                                        )
                                    );
                                }
                            });

                            finalValue = values.join(", ");
                        }

                        // OBJECT SECTION
                        else if (
                            typeof sectionData === "object" &&
                            sectionData !== null
                        ) {

                            finalValue = formatValue(
                                row.key,
                                sectionData[row.key]
                            );
                        }

                        rowObj[sampleId] = finalValue;
                    });

                    excelData.push(rowObj);
                }
            });


            /* =====================================================
                FOLLOWUP GROUPING
            ===================================================== */

            followupSections.forEach((sectionName) => {

                followupTypes.forEach((followupType) => {

                    // GET ALL UNIQUE KEYS
                    const fieldKeys = new Set();

                    partnerDataArray.forEach((dataItem) => {

                        const sectionData =
                            dataItem[sectionName] || [];

                        sectionData.forEach((item) => {

                            Object.keys(item).forEach((key) => {

                                if (!skipFields.includes(key)) {
                                    fieldKeys.add(key);
                                }
                            });
                        });
                    });

                    // CREATE ROWS
                    Array.from(fieldKeys).forEach((key) => {

                        const rowObj = {
                            "Sr No": srNo++,
                            "Form": formatLabel(sectionName),
                            "Label Name": formatLabel(key)
                        };

                        partnerDataArray.forEach((dataItem) => {

                            const sampleId =
                                dataItem?.male?.sample_id ||
                                "Unknown Sample";

                            const prd =
                                sampleId?.split("/")[2];

                            const sectionData =
                                dataItem[sectionName] || [];

                            let finalValue = "";

                            const matchedItem =
                                sectionData.find(
                                    item =>
                                        item.followup_type ===
                                        followupType
                                );

                            if (matchedItem) {

                                // show followup type
                                if (key === "followup_type") {

                                    finalValue = followupType;
                                }

                                // matched PRD
                                else if (prd === followupType) {

                                    finalValue = formatValue(
                                        key,
                                        matchedItem[key]
                                    );
                                }

                                // unmatched PRD
                                else {

                                    finalValue = "@";
                                }
                            }

                            rowObj[sampleId] = finalValue;
                        });

                        excelData.push(rowObj);
                    });
                });
            });

            /* =====================================================
                CREATE WORKSHEET
            ===================================================== */

            const worksheet =
                XLSX.utils.json_to_sheet(excelData);

            worksheet["!cols"] = [
                { wch: 8 },
                { wch: 35 },
                { wch: 45 },

                ...partnerDataArray.map(() => ({
                    wch: 35
                }))
            ];

            /* =====================================================
                WORKBOOK
            ===================================================== */

            const workbook =
                XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Multiple Samples Report"
            );

            /* =====================================================
                EXPORT FILE
            ===================================================== */

            const excelBuffer = XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );

            const blob = new Blob(
                [excelBuffer],
                {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
            );

            const today = new Date();

            const formattedDate =
                `${today.getFullYear()}-` +
                `${String(today.getMonth() + 1).padStart(2, "0")}-` +
                `${String(today.getDate()).padStart(2, "0")}`;

            saveAs(
                blob,
                `Multiple_Samples_Report_${formattedDate}.xlsx`
            );

        } catch (error) {

            console.error(
                "Excel Export Error:",
                error
            );
        }
    };

    ////////////////////////////////////////////////////////////////////////////////


    const columns = [
        {
            key: "index",
            label: "Sr. No",
            format: (_, __, index) => index + 1,
        },
        {
            key: "male_sample_id",
            label: "Sample Id",
            align: "left",
            format: (_, row) => (
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        dispatch(setSampleCode(row.male_sample_id))
                    }
                >
                    {row.male_sample_id}
                </span>
            ),
        },
        { key: "male_crn", label: "Male CRN" },
        { key: "female_crn", label: "Female CRN" },
        {
            key: "center",
            label: "Center Name / Code",
            format: (_, row) =>
                `${row.center_name || ""} / ${row.center_code || ""}`,
            searchValue: (row) =>
                `${row.center_name || ""} ${row.center_code || ""}`
        },
        { key: "created_by", label: "Created By" },
        {
            key: "created_date",
            label: "Created Date",
            format: formatDate,
            searchValue: (row) => formatDate(row.created_date)
        },
        {
            key: "action",
            label: "Action",
            format: (_, row) => (
                <>
                    <Button
                        size="sm" title="Edit Sample ID Data"
                        className="me-2"
                        onClick={() => {
                            dispatch(setSampleCode(row.male_sample_id));
                            openPasswordModal(row.sample_master_id);
                        }}
                    >
                        Edit
                    </Button>

                    {status === "active" ? (
                        <Button
                            size="sm" title="Delete Sample ID Data"
                            variant="danger"
                            className="me-2"
                            onClick={() => {
                                dispatch(setSampleCode(row.male_sample_id));
                                deleteRecordModal(row.sample_master_id);
                            }}
                        >
                            <i className="fa fa-trash"></i>
                        </Button>
                    ) : (
                        <Button
                            size="sm"
                            variant="primary" title="Active Sample ID Data"
                            className="me-2"
                            onClick={() => {
                                dispatch(setSampleCode(row.male_sample_id));
                                activateRecordModel(row.sample_master_id);
                            }}
                        >
                            <i className="fa fa-undo"></i>
                        </Button>
                    )}

                    <Button
                        size="sm"
                        variant="info" className="me-2" title="Print Sample ID Data"
                        onClick={() => {
                            dispatch(setSampleCode(row.male_sample_id));
                            handlePrint(row.sample_master_id);
                        }}
                    >
                        <i className="fa fa-print"></i>
                    </Button>
                    <Button
                        size="sm" title="Export Sample ID Data"
                        variant="success" onClick={() => { handlePrint_Excel(row.sample_master_id); }}

                    >
                        <FaFileExcel />
                    </Button>


                </>
            ),
        },
    ];

    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Patient Report <span>
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                </span>{" "}
                    List</h3>
            </div>
            <div className="container mt-4">
                <div className="row mb-3">


                    <div className="col-md-4">
                        <label className="form-label"><b>Select Center</b></label>

                        <select
                            className="form-select"
                            value={center}
                            onChange={(e) => setCenter(e.target.value)}
                            required
                        >
                            <option value="">-- Select Center --</option>
                            {center_list.map((c) => (
                                <option key={c.centres_id} value={c.centres_id}>
                                    {c.center_name}
                                </option>
                            ))}
                        </select>


                    </div>



                    <div className="col-md-4">
                        <label className="form-label"><b>Enter Sample ID From</b></label>
                        <input
                            type="number"
                            min="0"
                            max="999"
                            step="1"
                            className="form-control"
                            value={sampleFrom}
                            onChange={(e) => {
                                const val = e.target.value;

                                if (val === "" || (Number(val) >= 0 && Number(val) <= 999)) {
                                    setSampleFrom(val);
                                }
                            }}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label"><b>Enter Sample ID To</b></label>
                        <input
                            type="number"
                            min="0"
                            max="999"
                            step="1"
                            className="form-control"
                            value={sampleTo}
                            onChange={(e) => {
                                const val = e.target.value;

                                if (val === "" || (Number(val) >= 0 && Number(val) <= 999)) {
                                    setSampleTo(val);
                                }
                            }}
                        />
                    </div>
                </div>

                {/*  Row 2: CRN, From Date, To Date */}
                <div className="row mb-3">
                    <div className="col-md-4">
                        <label className="form-label"><b>Enter CRN (comma separated)</b></label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            onChange={(e) =>
                                setCrn(
                                    e.target.value
                                        .split(",")
                                        .map(v => v.trim())
                                        .filter(v => v !== "")
                                )
                            }
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label"><b>Enter From Date</b></label>
                        <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label"><b>Enter To Date</b></label>
                        <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                </div>

                {/*    Row 3: Cycle, Procedure, Export Button */}
                <div className="row mb-3 align-items-end">
                    <div className="col-md-4">
                        <label className="form-label"><b>Select Cycle</b></label>

                        <Select
                            isMulti
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={optionsRomanNumbers}
                            value={cycle}
                            onChange={(selectedOptions) => setCycle(selectedOptions)} styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label"><b>Select Procedure</b></label>

                        <Select
                            isMulti
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={optionsProcedure}
                            value={procedure}
                            onChange={(selected) => setProcedure(selected)} styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </div>

                    <div className="col-md-4 d-flex justify-content-start">
                        <Button
                            size="lg"
                            variant="success"
                            className="mt-2" onClick={handleExportAllSamples}
                        >
                            <FaFileExcel /> Export All Sample ID Data
                        </Button>
                    </div>
                </div>
            </div>
            <TableComponent
                columns={columns}
                data={finalData}
                rowsPerPage={10}
                maxHeight={400}
                headerClass="table-dark"
            />
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                dialogClassName="soft-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                        {deleteMode ? "Confirm Delete" : "Confirm Password"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                            Enter your password
                        </Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="" autoComplete="off"
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                padding: "10px 15px",
                                fontSize: "0.95rem",
                                boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                            }}
                        />
                    </Form.Group>
                    {error && (
                        <p
                            className="text-danger mt-2"
                            style={{ fontSize: "0.9rem", fontWeight: 500 }}
                        >
                            {error}
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 18px",
                            fontWeight: 500,
                            boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={verifyPassword}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 20px",
                            fontWeight: 600,
                            background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                            border: "none",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                    >
                        Verify
                    </Button>
                </Modal.Footer>
            </Modal>


            <style>
                {`
.soft-modal .modal-content {
    border-radius: 20px;
    padding: 0;
    box-shadow: 0 10px 30px rgba(0,0,0,0.12);
    border: none;
    overflow: hidden;
}
`}
            </style>
        </Container >
    );
}

export default Patient_report_sample_id_wise;

<style>{`
        .tiny-input {
                    font-size: 12px;
                    height: 30px;            
                    padding: 4px 10px;
                    border-radius: 6px;
                    width: 100%;
                    min-width: 90px;
                    line-height: 1.2;
                    box-sizing: border-box;
                    }

                  
       

                    /* Remove select arrow */
                    .no-select-icon {
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    background-image: none !important;
                    }       
                    }.unit-input .form-control {
    border-right: 0;
`}
</style>